import React from 'react';
import { FolderRoot as Football } from 'lucide-react';

export default function FantasyFootballHero() {
  const scrollToGenerator = () => {
    document.getElementById('fantasy-football-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1566577739112-5180d4bf9390?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="American Football field"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-green-900 via-green-800 to-green-900 opacity-80"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <Football className="w-16 h-16 text-green-400 animate-bounce" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Fantasy Football Team Name Generator
        </h1>
        <p className="text-xl text-green-100 mb-8 max-w-3xl mx-auto">
          Create the perfect name for your fantasy football team with our AI-powered generator.
          Score big with clever puns, player references, and championship-worthy names.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-green-700/50 px-4 py-2 rounded-full text-white text-sm border border-green-500/30">
            Clever Puns
          </span>
          <span className="bg-green-700/50 px-4 py-2 rounded-full text-white text-sm border border-green-500/30">
            Pop Culture References
          </span>
          <span className="bg-green-700/50 px-4 py-2 rounded-full text-white text-sm border border-green-500/30">
            Player-Based Names
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-green-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-green-600 transition-all cursor-pointer transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
        >
          <Football className="w-5 h-5" />
          Generate Fantasy Team Names
        </button>
        <p className="mt-6 text-sm text-green-200 bg-green-800/30 inline-block px-4 py-2 rounded-full mx-auto">
          Trusted by over 10,000+ fantasy football managers worldwide
        </p>
      </div>
    </div>
  );
}